import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { ValidationUtils} from "@bequeathed/ngx-utils";

export function validatePostcode(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const isPostcodeValid = ValidationUtils.validPostCode(control.value);
        return !isPostcodeValid ? {
            invalid_postcode: true
        } : null;
    }
}
